<template>
    <div>
        <div class="modal fade" id="contactModal" tabindex="-1" role="dialog" aria-labelledby="myModalLabel">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                        <div class="my-title">
                            <el-image class="my-title-img" src="http://images.qidao123.com/static//danbao.jpg" alt=""></el-image>
                            <div class="my-title-text">
                                <p>怕风险？</p>
                                <p>怕买贵？怕被忽悠？怕买错？</p>
                            </div>
                        </div>
                        <div class="my-title-text1">
                            <p>放心留言：厂家高层急速回复，没有中间商和基层销售赚钱</p>
                            <p>全网第一家三方平台：专业顾问协助/仲裁</p>
                        </div>
                        <div class="modal-title" id="h4_contacttitle" style="text-align: center;margin-top: 25px;">问技术，问价格...</div>
                        <!-- <h4 class="modal-title" id="h4_contacttitle1">平台担保，厂家一对一急速回复</h4> -->
                    </div>
                    <div class="modal-body">
                        <form class="form-horizontal">
                            <input type="hidden" id="inputproductid" />
                            <input type="hidden" id="inputcontactmenu" />
                            <input type="hidden" id="inputcontacturl" />
                            <div class="row">
                                <div class="col-xs-10 col-xs-offset-1">
                                    <div class="form-group">
                                        <div class="input-style">
                                            <span>*</span>
                                            <el-select v-model="askType" placeholder="请选择咨询类别">
                                                <el-option v-for="item in options" :key="item.dictValue" :label="item.dictLabel"
                                                    :value="item.dictValue">
                                                </el-option>
                                            </el-select>
                                        </div>
                                        
                                    </div>
                                    <div class="form-group">
                                        <div class="input-style">
                                            <span>*</span>
                                            <div class="textarea-style contact-textarea">
                                                <textarea @input="textInput" v-model="textareaContent" id="txtconsultationContent" class="form-control" rows="5" placeholder="请写您的需求或想要咨询的问题,如果是项目需求,请描述清楚项目所在的区域、行业、用户信息等,方便平台对接（500字内）"></textarea>
                                                <div class="num"><span>{{currentCount}}</span>/500</div>
                                            </div>
                                            <!-- <textarea id="txtconsultationContent" class="form-control" rows="5" placeholder="请写您的需求或想要咨询的问题,如果是项目需求,请描述清楚项目所在的区域、行业、用户信息等,方便平台对接（500字内）..."></textarea> -->
                                        </div>
                                        
                                    </div>
                                    <div class="form-group">
                                        <label class="sr-only" for="exampleInputPassword3">联系人</label>
                                        <div class="input-style">
                                            <span>*</span>
                                            <input type="tell" class="form-control" id="txtcontacts" placeholder="请输入联系人姓名">
                                        </div>
                                        <span id="helpBlock2" class="sr-only text-danger">请输入联系人姓名</span>
                                    </div>
                                    <div class="form-group">
                                        <label class="sr-only" for="exampleInputPassword3">单位名称</label>
                                        <div class="input-style">
                                            <span>*</span>
                                            <input type="tell" class="form-control" id="txtcompanyName" placeholder="请输入单位名称">
                                        </div>
                                        
                                        <span id="helpBlock2" class="sr-only text-danger">请输入单位名称</span>
                                    </div>
                                    <div class="form-group">
                                        <label class="sr-only" for="exampleInputPassword3">邮箱</label>
                                        <div class="input-style">
                                            <span>*</span>
                                            <input type="tell" class="form-control" id="txtemail" placeholder="请输入常用邮箱">
                                        </div>
                                        
                                        <span id="helpBlock2" class="sr-only text-danger">请输正确格式的邮箱</span>
                                    </div>
                                    <div class="form-group">
                                        <label class="sr-only" for="exampleInputPassword3">手机号码</label>
                                        <div class="input-style">
                                            <span>*</span>
                                            <input @blur="phoneInputed" v-model="userPhone" type="tell" class="form-control" id="txtphone" placeholder="请输入手机号码">
                                        </div>
                                        
                                        <!-- <span id="helpBlock2" class="sr-only text-danger">请输入正确格式的手机号码</span> -->
                                        <span class="sr-only text-danger">请输入正确格式的手机号码</span>
                                    </div>
                                    <div class="form-group" v-if="showLogin == 0">
                                        <label class="sr-only" for="exampleInputPassword3">验证码{{ showLogin == 0 }}</label>
                                        <div class="input-group">
                                            <div class="input-style">
                                                <span>*</span>
                                                <input type="password" class="form-control" id="txtverCode"
                                                placeholder="请输入验证码">
                                            </div>
                                            
                                            <span class="input-group-btn">
                                                <button type="button" style="height: 35px;line-height: 35px;"
                                                    id="btnSendSms_contact" class="layui-btn layui-btn-lg layui-btn-normal"
                                                    onclick="sendSms('txtphone','btnSendSms_contact');">发送验证码</button>
                                            </span>
                                        </div>
                                    </div>
                                    <!--<div class="form-group">
                                        <div class="checkbox">
                                            <label>
                                                <input type="checkbox" value="">
                                                <a href="javascript:void(0)" data-toggle="modal" data-target="#protocolModal">同意隐私条款</a>
                                            </label>
                                        </div>
                                    </div>-->
                                    <div class="form-group">
                                        <button type="button" class="btn btn-primary btn-lg btn-block" @click="addcontact()">提  交</button>
                                    </div>
                                </div>
                            </div>
                            <div class="my-foot">
                                <div class="right-item">
                                    <div class="right-title">观点·报告</div>
                                    <div class="right-body">
                                        <span><span class="eb5">Qidao123.com</span>作为ToB产业门户，在内业有较深影响力，拥有数量众多的专家团队和网站私域数据平台，可为产业提供相关专题研究报告和市场竞争分析。</span>
                                    </div>
                                </div>
                                <div class="right-item" style="margin-top:20px">
                                    <div class="right-title">咨询·评测</div>
                                    <div class="right-body">
                                        <span>本着<span class="eb5">“真实”“客观”“中立”</span> 的价值观，依托平台专业技术能力，接受厂商和用户委托，提供专业的第三方评测服务并出具专业评测报告。</span>
                                    </div>
                                </div>
                                <div class="right-item" style="margin-top:20px">
                                    <div class="right-title">招投标论证/代理/监理</div>
                                    <div class="right-body">
                                        <span><span class="eb5">Qidao123.com</span>专业团队凭借20年代的ToB的行业经验和庞大专家库，为生态提供复杂项目的需求论证和专业的招投标代理及监理工作，为项目保驾护航。</span>
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
        <!--咨询弹窗-->
        <!-- 提交成功弹窗 -->
        <el-dialog
            title="提交成功"
            :visible.sync="dialogVisible"
            width="30%"
            center>
            <div class="contact-tip-text">
                <div>厂商或管理员会第一时间联系您</div>
                <div>qidao123.com企服评测市场定会不负所托</div>
                <div v-if="!isRegister" class="noreg">您还未注册，将无法及时接收管理员咨询回复</div>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button v-if="!isRegister" style="background-color: #eb5412; color: #fff" @click="goRegister">注册</el-button>
                <el-button type="primary" @click="dialogVisible = false">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>
<script>
import { addcontact } from '../api/qdw/common'
export default {
    name: 'contact-model',
    components: {},
    props: {
        show: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            showLogin: localStorage.getItem('showLogin'),
            options: [],
            askType: '',//咨询类别
            textareaContent:'',
            dialogVisible:false,
            userPhone:'',
            isRegister:false,
        }
    },
    computed: {
        currentCount() {
            return this.textareaContent.length
        }
    },
    methods: {
        addcontact() {
            addcontact(this.askType,this);
        },
        textInput(){
            // console.log($('#txtconsultationContent').val());
            if (this.textareaContent.length > 500) {
                // 截断超出部分
                this.textareaContent = this.textareaContent.substring(0, 500)
                layer.alert('输入字数不能大于500字!', { icon: 6 });
            }
        },
        phoneInputed(){
            $.ajax({
                url: serverUrl + `/userdata/checkPhone?phone=${this.userPhone}`,
                type: "get",
                async: true,
                contentType: "application/json",
                success: (data)=> {
                if (data.code == 200) {
                        this.isRegister = data.data
                    }
                }
            })
        },
        goRegister(){
            window.location = "/register"
        }
    },
    mounted: function () {
        //获取咨询类别
        this.$get("/system/dict/data/type/ask_type").then((response) => {
            if (response.code == 200) {
                this.options = response.data
            }else{
                this.options = []
            }
        })
        let authdata = localStorage.getItem("authdata");
        let showLogin = localStorage.getItem("showLogin");
        this.isRegister = showLogin == 1 ? true : false
        if (authdata != null) {
            let user = JSON.parse(authdata);
            // 联系人姓名
            $('#txtcontacts').val(user.data.realName);
            // 单位名称
            $('#txtcompanyName').val(user.data.companyName);
            // 邮箱
            $('#txtemail').val(user.data.userEmail);
            // 电话号码
            // $('#txtphone').val(user.data.userPhone);
            this.userPhone = user.data.userPhone
        }
    },
}
</script>

<style scoped>
>>>.el-select {
    width: 100% !important;
}

>>>input::-webkit-input-placeholder {
    color: rgba(153, 153, 153, 1);
}

>>>input::-moz-input-placeholder {
    color: rgba(153, 153, 153, 1);
}

>>>input::-ms-input-placeholder {
    color: rgba(153, 153, 153, 1);
}


>>>.el-input__inner {
    border: 1px solid #ccc !important;
    box-shadow: inset 0 1px 1px rgba(0, 0, 0, .075) !important;
    transition: border-color ease-in-out .15s, box-shadow ease-in-out .15s;
}
.contact-textarea >>> .form-control::-webkit-input-placeholder {
    color: #f1bb21;
}
</style>

<style lang="scss" scoped>
.layui-btn-normal {
    background-color: #EB5412;
}

h4 {
    //text-align: center;
    margin-left: 32px;
    padding-top: 15px;
    font-weight: bold;
    font-size: 15px;
}

.modal-header {
    padding-top: 10px !important;
    padding-bottom: 2px !important;
}

.form-control {
    //font-style: italic;
}
.my-title{
  display: flex;
  position: relative;
  align-items: center;
  justify-content: center;
  font-size: 20px;
  font-weight: 700;
  color: #EB5412;
}
.my-title-text{
  margin-left: 40px;
  text-align: center;
}
.my-title-img{
  position: absolute;
  top: 16px;
  left:25px;
  width: 100px;
}
.my-title-text p:nth-child(1){
  margin-top: 15px;
  // margin-left: 72px;
}
.my-title-text p:nth-child(2){
  margin-top: 5px;
}
.my-title-text1{
  margin-top: 10px;
  text-align: center;
  margin-left: 55px;
}
.my-title-text1 p:nth-child(2){
  margin-top: 5px;
}
.my-foot{
  margin-top: 15px;
  padding: 0 32px;
}
.right-item{
  &:not(:nth-child(1)){
    margin-top: 5px;
  }
  .right-title{
    padding-bottom: 5px;
    font-size: 16px;
    font-weight: 700;
    // display: flex;
    // align-items: center;
    // justify-content: center;
    border-bottom: 1px solid #eee;
  }
  .right-body{
    &>span{
      display: inline-block;
      margin-top: 5px;
      line-height: 22px;
    }
  }
}
.input-style{
    display: flex;
    align-items: center;
    &>span{
        color: #eb5412;
        margin-right: 5px;
        font-size: 18px;
    }
}
.textarea-style{
    width: 100%;
    position: relative;
    .num{
        color: #999;
        position: absolute;
        right: 10px;
        bottom: 0px;
    }
}
.contact-tip-text{
    text-align: center;
    line-height: 2;
    .noreg{
        font-weight: 600;
        color: #eb5412;
        margin-top: 30px;
    }
}
</style>